import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "Icon",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10 0a10 10 0 1 0 10 10A10.012 10.012 0 0 0 10 0ZM8.929 5a1.071 1.071 0 1 1 2.142 0v4.286a1.071 1.071 0 0 1-2.142 0V5Zm1.07 10.714A1.428 1.428 0 1 1 10 12.858a1.428 1.428 0 0 1 0 2.856Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }